import { render } from "./ThankYouText.vue?vue&type=template&id=19080d94&scoped=true"
import script from "./ThankYouText.vue?vue&type=script&lang=js"
export * from "./ThankYouText.vue?vue&type=script&lang=js"

import "./ThankYouText.vue?vue&type=style&index=0&id=19080d94&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19080d94"]])

export default __exports__